import { ReactElement } from "react";
import { useFormContext } from "react-hook-form";

import { IntegrationMasterForm } from "../types/form-inputs.ts";
import { CardLayout } from "./CardLayout.tsx";
import InputFieldGroup from "./inputs/InputFieldGroup.tsx";

const GoogleIntegrationDetails = (): null | ReactElement => {
  const methods = useFormContext<IntegrationMasterForm>();

  const {
    formState: { errors },
    register,
  } = methods;

  return (
    <>
      <CardLayout header={<>API Key</>}>
        <div className="mt-6 space-y-6">
          <div className="w-full">
            <InputFieldGroup<IntegrationMasterForm>
              errors={errors}
              fieldName="googleClientEmail"
              label="Client Email"
              placeHolder="runreveal@runreveal-gworkspace.iam.gserviceaccount.com"
              register={register}
              rules={{
                required: "Please enter a Client Email",
              }}
              tooltip={{
                position: "right",
                text: "The client_email from your google service credential json",
              }}
              type="email"
            />
          </div>
          <div className="w-full">
            <InputFieldGroup<IntegrationMasterForm>
              errors={errors}
              fieldName="googlePrivateKeyId"
              label="Private Key ID"
              placeHolder="ee3ea6e8fca240a5d001e16507cd99fd7e5319a7"
              register={register}
              rules={{
                required:
                  "The private_key_id from your google service credential json",
              }}
            />
          </div>
          <div className="w-full">
            <InputFieldGroup<IntegrationMasterForm>
              errors={errors}
              fieldName="googlePrivateKey"
              label="Private Key"
              multiline={true}
              placeHolder="-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0BAQEFAASC...\n-----END PRIVATE KEY-----\n"
              register={register}
              rows={10}
              rules={{
                required:
                  "The private_key from your google service credential json",
              }}
            />
          </div>
          <div className="w-full">
            <InputFieldGroup<IntegrationMasterForm>
              errors={errors}
              fieldName="googleDelegatedAdminEmail"
              label="Delegated Admin Email"
              placeHolder="runreveal@runreveal-gworkspace.iam.gserviceaccount.com"
              register={register}
              rules={{
                required: "Please enter a Delegated Admin Email",
              }}
              tooltip={{
                position: "right",
                text: "The subject must be an administrator of your google workspace account, usually it will be the email address of the person who performed the domain-wide delegation",
              }}
              type="email"
            />
          </div>
        </div>
      </CardLayout>
    </>
  );
};

export default GoogleIntegrationDetails;
